export enum EnvironmentEnum {
  LOCALHOST = 'localhost',
  QA = 'qa',
  PRODUCTION = 'production',
}
